import { render, staticRenderFns } from "./avatar-employees.vue?vue&type=template&id=ef59c02e&"
import script from "./avatar-employees.vue?vue&type=script&lang=js&"
export * from "./avatar-employees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports